import React, { Component } from 'react';
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell
} from "@mui/material";
import TextField from '@mui/material/TextField';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import InputAdornment from '@mui/material/InputAdornment';
import SimpleReactValidator from "simple-react-validator";
import { Spinner } from 'react-bootstrap';
import { sweetConfirmAlert, sweetErrorAlert, sweetStatusAlert, sweetSuccessAlert } from '../../../components/common/SweetAlert';
import ContentWrapper from '../../../components/common/ContentWrapper';
import config from '../../../helper/config';
import {customerConstants} from "../../../helper/constants.js";
import { employmentTypeService } from '../../../service/settings/manage/employment_type.service.js';

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle
const customer = getCustomerFeatureFlag()
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent"
    }
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent"
    }
    break
  default:
    break
}

class ManageEmployeeType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTableDataLoading:false,
      isLoading:false,
      addTypeModal: false,
      updateTypeModal:false,
      type: "",
      updateType:"",
      selectedType:null,
      types:[],
      update_desc:"",
      description:"",
      update_employment_code:"",
      employment_code:""
    };
    this.validator = new SimpleReactValidator();
  }

  componentDidMount(){
    this.getAllEmploymentType()
  }

  getAllEmploymentType=()=>{
    this.setState({ isTableDataLoading: true });
    employmentTypeService.getAllEmpTypes()
        .then((response)=>{
            if(response.success){
                this.setState({types:response.data, isTableDataLoading:false})
            }
            else{
                this.setState({ isTableDataLoading: false });
            }
            
        })
  }

  toggleAddEmpModal = () => {
    const { addTypeModal } = this.state;
    this.validator.purgeFields()
    this.validator.hideMessageFor("type")
    this.setState({
        addTypeModal: !addTypeModal,
        type: "",
    });
  };

  toggleUpdateEmpModal = (type) => {
    const { updateTypeModal,  } = this.state;
    this.validator.purgeFields()
    this.validator.hideMessages()
    if(!updateTypeModal){
        this.setState({updateType:type.employment_type , selectedType:type.type_id , update_desc:type.description, update_employment_code:type.employment_code, updateTypeModal:true})
    }
    else{
        this.setState({updateType:"", selectedType:null , updateTypeModal:false, update_desc:"",update_employment_code:""})
    }
  };

  handleSubmit = () => {
    const { type ,description, employment_code} = this.state;
    if (!this.validator.fieldValid("type")) {
      this.validator.showMessageFor("type")
      this.forceUpdate();
    } else {
    this.setState({isLoading:true})
      const newEmp = {
        employment_type:type,
        description:description,
        employment_code:employment_code
      }
      employmentTypeService.add(newEmp)
        .then((response)=>{
            if(response.success){
                this.setState({isLoading:false})
                this.toggleAddEmpModal()
                sweetSuccessAlert("Success","Employee Type added successfully","success")
                this.getAllEmploymentType()
            }
            else{
                this.setState({isLoading:false})
                sweetStatusAlert("Info",response.message,"info")
            }
        })
        .catch((error)=>{
            this.setState({isLoading:false})
            sweetErrorAlert("Error","Error while adding type","error")
        })
    }
  };

  handleEditSubmit = ()=>{
    const {updateType,selectedType,update_desc,update_employment_code} = this.state;
    if(!this.validator.fieldValid("updateType")){
        this.validator.showMessageFor("updateType")
        this.forceUpdate();
    }
    else{
        this.setState({isLoading:true})
        const newUpdateEmp = {
            employment_type:updateType,
            description:update_desc,
            employment_code:update_employment_code
        }
        employmentTypeService.update(newUpdateEmp, selectedType)
            .then((response)=>{
                if(response.success){
                    sweetStatusAlert("Success!", response.message.success, "success");
                    this.setState({isLoading:false})
                    this.toggleUpdateEmpModal()
                    this.getAllEmploymentType()
                }
                else{
                    this.setState({isLoading:false})
                    sweetStatusAlert("Oops",response.message.error,"info")
                }
                
            })

    }
  }

  handleDeleteEmp = (id)=>{
    sweetConfirmAlert()
        .then(()=>{
            this.setState({isTableDataLoading:true})
            employmentTypeService.deleteEmpTypes(id)
                .then((response)=>{
                    if(response.success){
                    sweetSuccessAlert("Success", response.message.success,"success")
                    this.getAllEmploymentType()
                    }else{
                    sweetStatusAlert("Oops",response.message.error,"info")
                    this.setState({isTableDataLoading:false})
                    }
                })
                .catch((error)=>{
                    sweetStatusAlert("Oops","Error while deleting type","info")
                    this.setState({isTableDataLoading:false})
                })
        })
  }

  handleEmpChange = (e) => {
    const { name,value } = e.target;
    this.setState(() => ({ [name]: value }));
  };


  render() {
    const { 
        addTypeModal, 
        type, 
        updateTypeModal,
        isTableDataLoading,
        isLoading,
        types,
        updateType,
        description,
        update_desc,
        employment_code,
        update_employment_code
        } = this.state;

    return (
      <ContentWrapper>
        <div className="row justify-content-between align-items-center py-5 mb-3">
          <div className="col-md-6 col-6">
            <h3 className='text-nowrap'>Manage Employee Type</h3>
          </div>
          <Button
            className="insert-btn"
            variant="primary"
            onClick={this.toggleAddEmpModal}
          >
            Add Employee Type
          </Button>
        </div>
        {isTableDataLoading ? (
          <div
            className="loading-container"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "75vw",
              height: "90vh"
            }}
          >
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <div style={{ width: "75vw", height: "90vh", overflowX: "auto", overflowY: "auto" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className="thead">Employee Type</TableCell>
                  <TableCell className="thead">Description</TableCell>
                  <TableCell className="thead">Employment Code </TableCell>
                  <TableCell className="thead d-flex justify-content-end">Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {types.length > 0 ? (
                  types.map((type) => (
                    <TableRow key={type.type_id}>
                      <TableCell className="tData">{type.employment_type}</TableCell>
                      <TableCell className="thead">{type.description}</TableCell>
                      <TableCell className="thead">{type.employment_code}</TableCell>
                      <TableCell className="tData" align="right">
                        <Button
                          onClick={() => this.toggleUpdateEmpModal(type)}
                          className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                          title="Edit Details"
                        />

                        <Button
                          onClick={() => this.handleDeleteEmp(type.type_id)}
                          className="btn btn-icon btn-danger btn-sm m-1 delete-assement-btn flaticon-delete"
                          title="Delete"
                        />
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <div style={{ height: "90vh" }}>No types available</div>
                )}
              </TableBody>
            </Table>
          </div>
        )}

        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={addTypeModal}
          onHide={this.toggleAddEmpModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Create New Employee Type</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {isLoading ? (
              <div className="loading-container" style={{ height: "50px" }}>
                <Spinner animation="border" role="status">
                  <span className="sr-only">Please wait...</span>
                </Spinner>
              </div>
            ) : (
              <Form>
                <Row className="my-5">

                  <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Employee Type*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Employee Type Name"
                    name="type"
                    onChange={this.handleEmpChange}
                  />
                  {this.validator.message(
                    "type",
                    type,
                    "required|alpha_space",
                    {
                      className: "text-danger",
                      messages: {
                        required: "The Employee Type name field is required.",
                        alpha_space:
                          "The Employee Type name must have valid characters.",
                      },
                    }
                  )}
                </Form.Group>
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Description"
                    name="description"
                    onChange={this.handleEmpChange}
                  />
                
                </Form.Group>
                </Row>
                <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Employment Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="employment Code"
                    name="employment_code"
                    onChange={this.handleEmpChange}
                  />
                
                </Form.Group>
                </Row>
              </Form>
            )}

            <Modal.Footer>
              <Button
                className="modal-btn"
                variant="primary"
                style={ addBtnStyle }
                onClick={this.handleSubmit}
              >
                Save
              </Button>
              <Button
                sx={{ mr: "20px" }}
                onClick={this.toggleAddEmpModal}
                className="modal-btn"
                id="modal-close-button"
                style={ closeBtnStyle }
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal.Body>
        </Modal>

        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={updateTypeModal}
          onHide={this.toggleUpdateEmpModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Employee Type</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {isLoading ? (
              <div className="loading-container" style={{ height: "50px" }}>
                <Spinner animation="border" role="status">
                  <span className="sr-only">Please wait...</span>
                </Spinner>
              </div>
            ) : (
                <Form>
                <Row className="my-5">

                  <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Employee Type*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Employee Type Name"
                    name="updateType"
                    value={updateType}
                    onChange={this.handleEmpChange}
                  />
                  {this.validator.message(
                    "updateType",
                    updateType,
                    "required|alpha_space",
                    {
                      className: "text-danger",
                      messages: {
                        required: "The Employee Type name field is required.",
                        alpha_space:
                          "The Employee Type name must have valid characters.",
                      },
                    }
                  )}
                </Form.Group>
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Description"
                    name="update_desc"
                    value={update_desc}
                    onChange={this.handleEmpChange}
                  />
                
                </Form.Group>
                </Row>
                <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Employment Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Employment Code"
                    name="update_employment_code"
                    value={update_employment_code}
                    onChange={this.handleEmpChange}
                  />
                
                </Form.Group>
                </Row>
              </Form>
            )}

            <Modal.Footer>
              <Button
                className="modal-btn"
                variant="primary"
                style={ addBtnStyle }
                onClick={() => this.handleEditSubmit()}
              >
                Save
              </Button>
              <Button
                className="modal-btn"
                id="modal-close-button"
                style={ closeBtnStyle }
                sx={{ mr: "20px" }}
                onClick={this.toggleUpdateEmpModal}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal.Body>
        </Modal>
      </ContentWrapper>
    )
  }
}

export default ManageEmployeeType;
